import React from 'react';
import { DetailSection, DetailRow, LinkChip, ChipGrid, StatusBadge } from './detail-primitives';

const ParentDetail = ({ data, onOpen }) => (
  <div className="space-y-3" data-testid="parent-detail-body">
    <DetailSection title="بطاقة ولي الأمر">
      <DetailRow label="الاسم" value={data.full_name} testId="parent-full-name" />
      <DetailRow label="الحالة" value={<StatusBadge status={data.status} />} />
      <DetailRow label="الجوال" value={data.phone_number} testId="parent-phone" />
      <DetailRow label="واتساب" value={data.whatsapp_number} />
      <DetailRow label="البريد" value={data.email} />
    </DetailSection>

    <DetailSection title={`الأبناء (${data.children_count ?? (data.children || []).length})`}>
      <ChipGrid empty="لا يوجد أبناء مرتبطون بهذا الحساب.">
        {(data.children || []).map((ch) => (
          <LinkChip
            key={ch.id || ch.full_name}
            kind="student"
            id={ch.id}
            onOpen={ch.id ? onOpen : undefined}
            label={ch.full_name || 'طالب'}
            sub={[ch.program_name, ch.level_name, ch.status].filter(Boolean).join(' • ')}
            testId={`parent-child-link-${ch.id || ch.full_name}`}
          />
        ))}
      </ChipGrid>
    </DetailSection>
  </div>
);

export default ParentDetail;
